import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=a3d81f30"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"
import style0 from "./recovery.vue?vue&type=style&index=0&id=a3d81f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports